import { getHigherRole } from "@utils/member-utils";
import { getPrettyName } from "@utils/user-utils";
import { getTeamsSortBy, isAutoManagedTeamKind } from "@utils/team-utils";
import { convertGridSortModelToSortBy } from "@utils/sort-utils";
import { DEFAULT_TEAMS_SORT_BY } from "@components/teams/teams-constants";
import { isTeamsSortField } from "@custom-types/type-guards";
import { PALETTE_VARS } from "@styles/palette-vars";

/**
 * Maps team members to sdb members by calculating the higher role of the member
 * based on the team role and company role if companyMembersMap is provided
 */
export function mapTeamMembersToSdbMembers(members, teamRole, companyMembers) {
  return members.map(member => {
    const companyRole = companyMembers?.get(member.userResponse.identity)?.role;
    return {
      ...member.userResponse,
      dateJoined: member.addedAt,
      name: getPrettyName(member.userResponse),
      role: companyRole ? getHigherRole(teamRole, companyRole) : teamRole
    };
  });
}

/** Properties for the chip icon shown for auto-managed teams. */

const AUTO_MANAGED_TEAM_COLOR = PALETTE_VARS.tertiary.light;
const AUTO_MANAGED_TEAM_LABEL = "Auto-managed";
const AUTO_MANAGED_TEAM_CHIP_PROPS = {
  border: PALETTE_VARS.Chip.tertiary.outline,
  background: PALETTE_VARS.Chip.tertiary.background,
  icon: PALETTE_VARS.tertiary.light
};
export const teamDisplayProperties = {
  ["email-domains"]: {
    isAutoManaged: isAutoManagedTeamKind("email-domains"),
    color: AUTO_MANAGED_TEAM_COLOR,
    label: AUTO_MANAGED_TEAM_LABEL,
    description: "Users who log in via the configured SSO connection are automatically invited to this team.",
    chipProps: AUTO_MANAGED_TEAM_CHIP_PROPS
  },
  ["all-members"]: {
    isAutoManaged: isAutoManagedTeamKind("all-members"),
    color: AUTO_MANAGED_TEAM_COLOR,
    label: AUTO_MANAGED_TEAM_LABEL,
    description: "All members invited to the workspace are automatically invited to this team.",
    chipProps: AUTO_MANAGED_TEAM_CHIP_PROPS
  },
  ["default"]: {
    isAutoManaged: isAutoManagedTeamKind("default"),
    color: PALETTE_VARS.text.secondary,
    label: null,
    description: null,
    chipProps: null
  }
};

/**
 * @returns a valid teams `sortBy` option from the passed GridSortModel
 * @param gridSortModel Teams table sort model
 */
export function getSortByFromGridSortModel(gridSortModel) {
  return convertGridSortModelToSortBy(gridSortModel, {
    defaultSortBy: DEFAULT_TEAMS_SORT_BY,
    isValidSortField: isTeamsSortField,
    getSortBy: getTeamsSortBy
  });
}